import { render, staticRenderFns } from "./BetMatchDetailsSwiper.vue?vue&type=template&id=2b7a9e2e&scoped=true"
import script from "./BetMatchDetailsSwiper.vue?vue&type=script&lang=js"
export * from "./BetMatchDetailsSwiper.vue?vue&type=script&lang=js"
import style0 from "./BetMatchDetailsSwiper.vue?vue&type=style&index=0&id=2b7a9e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a9e2e",
  null
  
)

export default component.exports